document.addEventListener("DOMContentLoaded", function () {

  const thumbs = document.querySelectorAll(".custom-thumb");
  const mainImage = document.getElementById("custom-main-image");

  thumbs.forEach(thumb => {
    thumb.addEventListener("click", function () {
      mainImage.src = this.src.replace("width=200", "width=1200");
    });
  });

});